module.exports = __webpack_public_path__ + "img/1.d0ab8d2a.jpg";